/* tslint:disable */
/* eslint-disable */
/**
 * API
 * API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { ContactSearchResponseDto } from '../models';
// @ts-ignore
import type { CreateSupplierRequestDto } from '../models';
// @ts-ignore
import type { SupplierContactsSearchRequestDto } from '../models';
// @ts-ignore
import type { SupplierDto } from '../models';
// @ts-ignore
import type { SupplierIdDto } from '../models';
// @ts-ignore
import type { SupplierSearchRequestDto } from '../models';
// @ts-ignore
import type { SupplierSearchResponseDto } from '../models';
// @ts-ignore
import type { UpdateSupplierRequestDto } from '../models';
/**
 * RestSuppliersApi - axios parameter creator
 */
export const RestSuppliersApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Add contact to supplier
         * @param {number} supplierId 
         * @param {number} contactId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addSupplierContact: async (supplierId: number, contactId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'supplierId' is not null or undefined
            assertParamExists('addSupplierContact', 'supplierId', supplierId)
            // verify required parameter 'contactId' is not null or undefined
            assertParamExists('addSupplierContact', 'contactId', contactId)
            const localVarPath = `/api/suppliers/{supplierId}/contacts/{contactId}`
                .replace('{supplierId}', encodeURIComponent(String(supplierId)))
                .replace('{contactId}', encodeURIComponent(String(contactId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CreateSupplierRequestDto} createSupplierRequestDto Create supplier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSupplier: async (createSupplierRequestDto: CreateSupplierRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createSupplierRequestDto' is not null or undefined
            assertParamExists('createSupplier', 'createSupplierRequestDto', createSupplierRequestDto)
            const localVarPath = `/api/suppliers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createSupplierRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete contact from supplier
         * @param {number} supplierId 
         * @param {number} contactId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSupplierContact: async (supplierId: number, contactId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'supplierId' is not null or undefined
            assertParamExists('deleteSupplierContact', 'supplierId', supplierId)
            // verify required parameter 'contactId' is not null or undefined
            assertParamExists('deleteSupplierContact', 'contactId', contactId)
            const localVarPath = `/api/suppliers/{supplierId}/contacts/{contactId}`
                .replace('{supplierId}', encodeURIComponent(String(supplierId)))
                .replace('{contactId}', encodeURIComponent(String(contactId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} supplierId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSupplier: async (supplierId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'supplierId' is not null or undefined
            assertParamExists('getSupplier', 'supplierId', supplierId)
            const localVarPath = `/api/suppliers/{supplierId}`
                .replace('{supplierId}', encodeURIComponent(String(supplierId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get list of suppliers contacts
         * @param {number} page 
         * @param {number} pageSize 
         * @param {number} supplierId 
         * @param {SupplierContactsSearchRequestDto} supplierContactsSearchRequestDto Supplier contacts search request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchSupplierContacts: async (page: number, pageSize: number, supplierId: number, supplierContactsSearchRequestDto: SupplierContactsSearchRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'page' is not null or undefined
            assertParamExists('searchSupplierContacts', 'page', page)
            // verify required parameter 'pageSize' is not null or undefined
            assertParamExists('searchSupplierContacts', 'pageSize', pageSize)
            // verify required parameter 'supplierId' is not null or undefined
            assertParamExists('searchSupplierContacts', 'supplierId', supplierId)
            // verify required parameter 'supplierContactsSearchRequestDto' is not null or undefined
            assertParamExists('searchSupplierContacts', 'supplierContactsSearchRequestDto', supplierContactsSearchRequestDto)
            const localVarPath = `/api/suppliers/{supplierId}/contacts-search`
                .replace('{supplierId}', encodeURIComponent(String(supplierId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(supplierContactsSearchRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get list of suppliers
         * @param {number} page 
         * @param {number} pageSize 
         * @param {SupplierSearchRequestDto} supplierSearchRequestDto Supplier search request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchSuppliers: async (page: number, pageSize: number, supplierSearchRequestDto: SupplierSearchRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'page' is not null or undefined
            assertParamExists('searchSuppliers', 'page', page)
            // verify required parameter 'pageSize' is not null or undefined
            assertParamExists('searchSuppliers', 'pageSize', pageSize)
            // verify required parameter 'supplierSearchRequestDto' is not null or undefined
            assertParamExists('searchSuppliers', 'supplierSearchRequestDto', supplierSearchRequestDto)
            const localVarPath = `/api/suppliers/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(supplierSearchRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} supplierId 
         * @param {UpdateSupplierRequestDto} updateSupplierRequestDto Update business supplier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSupplier: async (supplierId: number, updateSupplierRequestDto: UpdateSupplierRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'supplierId' is not null or undefined
            assertParamExists('updateSupplier', 'supplierId', supplierId)
            // verify required parameter 'updateSupplierRequestDto' is not null or undefined
            assertParamExists('updateSupplier', 'updateSupplierRequestDto', updateSupplierRequestDto)
            const localVarPath = `/api/suppliers/{supplierId}`
                .replace('{supplierId}', encodeURIComponent(String(supplierId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateSupplierRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * RestSuppliersApi - functional programming interface
 */
export const RestSuppliersApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = RestSuppliersApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Add contact to supplier
         * @param {number} supplierId 
         * @param {number} contactId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addSupplierContact(supplierId: number, contactId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addSupplierContact(supplierId, contactId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestSuppliersApi.addSupplierContact']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {CreateSupplierRequestDto} createSupplierRequestDto Create supplier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createSupplier(createSupplierRequestDto: CreateSupplierRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SupplierIdDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createSupplier(createSupplierRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestSuppliersApi.createSupplier']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Delete contact from supplier
         * @param {number} supplierId 
         * @param {number} contactId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteSupplierContact(supplierId: number, contactId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteSupplierContact(supplierId, contactId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestSuppliersApi.deleteSupplierContact']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} supplierId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSupplier(supplierId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SupplierDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSupplier(supplierId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestSuppliersApi.getSupplier']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get list of suppliers contacts
         * @param {number} page 
         * @param {number} pageSize 
         * @param {number} supplierId 
         * @param {SupplierContactsSearchRequestDto} supplierContactsSearchRequestDto Supplier contacts search request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchSupplierContacts(page: number, pageSize: number, supplierId: number, supplierContactsSearchRequestDto: SupplierContactsSearchRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ContactSearchResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.searchSupplierContacts(page, pageSize, supplierId, supplierContactsSearchRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestSuppliersApi.searchSupplierContacts']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get list of suppliers
         * @param {number} page 
         * @param {number} pageSize 
         * @param {SupplierSearchRequestDto} supplierSearchRequestDto Supplier search request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchSuppliers(page: number, pageSize: number, supplierSearchRequestDto: SupplierSearchRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SupplierSearchResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.searchSuppliers(page, pageSize, supplierSearchRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestSuppliersApi.searchSuppliers']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} supplierId 
         * @param {UpdateSupplierRequestDto} updateSupplierRequestDto Update business supplier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateSupplier(supplierId: number, updateSupplierRequestDto: UpdateSupplierRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateSupplier(supplierId, updateSupplierRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestSuppliersApi.updateSupplier']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * RestSuppliersApi - factory interface
 */
export const RestSuppliersApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = RestSuppliersApiFp(configuration)
    return {
        /**
         * 
         * @summary Add contact to supplier
         * @param {number} supplierId 
         * @param {number} contactId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addSupplierContact(supplierId: number, contactId: number, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.addSupplierContact(supplierId, contactId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CreateSupplierRequestDto} createSupplierRequestDto Create supplier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSupplier(createSupplierRequestDto: CreateSupplierRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<SupplierIdDto> {
            return localVarFp.createSupplier(createSupplierRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete contact from supplier
         * @param {number} supplierId 
         * @param {number} contactId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSupplierContact(supplierId: number, contactId: number, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteSupplierContact(supplierId, contactId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} supplierId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSupplier(supplierId: number, options?: RawAxiosRequestConfig): AxiosPromise<SupplierDto> {
            return localVarFp.getSupplier(supplierId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get list of suppliers contacts
         * @param {number} page 
         * @param {number} pageSize 
         * @param {number} supplierId 
         * @param {SupplierContactsSearchRequestDto} supplierContactsSearchRequestDto Supplier contacts search request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchSupplierContacts(page: number, pageSize: number, supplierId: number, supplierContactsSearchRequestDto: SupplierContactsSearchRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<ContactSearchResponseDto> {
            return localVarFp.searchSupplierContacts(page, pageSize, supplierId, supplierContactsSearchRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get list of suppliers
         * @param {number} page 
         * @param {number} pageSize 
         * @param {SupplierSearchRequestDto} supplierSearchRequestDto Supplier search request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchSuppliers(page: number, pageSize: number, supplierSearchRequestDto: SupplierSearchRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<SupplierSearchResponseDto> {
            return localVarFp.searchSuppliers(page, pageSize, supplierSearchRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} supplierId 
         * @param {UpdateSupplierRequestDto} updateSupplierRequestDto Update business supplier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSupplier(supplierId: number, updateSupplierRequestDto: UpdateSupplierRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateSupplier(supplierId, updateSupplierRequestDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * RestSuppliersApi - interface
 */
export interface RestSuppliersApiInterface {
    /**
     * 
     * @summary Add contact to supplier
     * @param {number} supplierId 
     * @param {number} contactId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    addSupplierContact(supplierId: number, contactId: number, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * 
     * @param {CreateSupplierRequestDto} createSupplierRequestDto Create supplier
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createSupplier(createSupplierRequestDto: CreateSupplierRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<SupplierIdDto>;

    /**
     * 
     * @summary Delete contact from supplier
     * @param {number} supplierId 
     * @param {number} contactId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteSupplierContact(supplierId: number, contactId: number, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * 
     * @param {number} supplierId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getSupplier(supplierId: number, options?: RawAxiosRequestConfig): AxiosPromise<SupplierDto>;

    /**
     * 
     * @summary Get list of suppliers contacts
     * @param {number} page 
     * @param {number} pageSize 
     * @param {number} supplierId 
     * @param {SupplierContactsSearchRequestDto} supplierContactsSearchRequestDto Supplier contacts search request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    searchSupplierContacts(page: number, pageSize: number, supplierId: number, supplierContactsSearchRequestDto: SupplierContactsSearchRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<ContactSearchResponseDto>;

    /**
     * 
     * @summary Get list of suppliers
     * @param {number} page 
     * @param {number} pageSize 
     * @param {SupplierSearchRequestDto} supplierSearchRequestDto Supplier search request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    searchSuppliers(page: number, pageSize: number, supplierSearchRequestDto: SupplierSearchRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<SupplierSearchResponseDto>;

    /**
     * 
     * @param {number} supplierId 
     * @param {UpdateSupplierRequestDto} updateSupplierRequestDto Update business supplier
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateSupplier(supplierId: number, updateSupplierRequestDto: UpdateSupplierRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<void>;

}

/**
 * RestSuppliersApi - object-oriented interface
 */
export class RestSuppliersApi extends BaseAPI implements RestSuppliersApiInterface {
    /**
     * 
     * @summary Add contact to supplier
     * @param {number} supplierId 
     * @param {number} contactId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public addSupplierContact(supplierId: number, contactId: number, options?: RawAxiosRequestConfig) {
        return RestSuppliersApiFp(this.configuration).addSupplierContact(supplierId, contactId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CreateSupplierRequestDto} createSupplierRequestDto Create supplier
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createSupplier(createSupplierRequestDto: CreateSupplierRequestDto, options?: RawAxiosRequestConfig) {
        return RestSuppliersApiFp(this.configuration).createSupplier(createSupplierRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete contact from supplier
     * @param {number} supplierId 
     * @param {number} contactId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deleteSupplierContact(supplierId: number, contactId: number, options?: RawAxiosRequestConfig) {
        return RestSuppliersApiFp(this.configuration).deleteSupplierContact(supplierId, contactId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} supplierId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getSupplier(supplierId: number, options?: RawAxiosRequestConfig) {
        return RestSuppliersApiFp(this.configuration).getSupplier(supplierId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get list of suppliers contacts
     * @param {number} page 
     * @param {number} pageSize 
     * @param {number} supplierId 
     * @param {SupplierContactsSearchRequestDto} supplierContactsSearchRequestDto Supplier contacts search request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public searchSupplierContacts(page: number, pageSize: number, supplierId: number, supplierContactsSearchRequestDto: SupplierContactsSearchRequestDto, options?: RawAxiosRequestConfig) {
        return RestSuppliersApiFp(this.configuration).searchSupplierContacts(page, pageSize, supplierId, supplierContactsSearchRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get list of suppliers
     * @param {number} page 
     * @param {number} pageSize 
     * @param {SupplierSearchRequestDto} supplierSearchRequestDto Supplier search request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public searchSuppliers(page: number, pageSize: number, supplierSearchRequestDto: SupplierSearchRequestDto, options?: RawAxiosRequestConfig) {
        return RestSuppliersApiFp(this.configuration).searchSuppliers(page, pageSize, supplierSearchRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} supplierId 
     * @param {UpdateSupplierRequestDto} updateSupplierRequestDto Update business supplier
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateSupplier(supplierId: number, updateSupplierRequestDto: UpdateSupplierRequestDto, options?: RawAxiosRequestConfig) {
        return RestSuppliersApiFp(this.configuration).updateSupplier(supplierId, updateSupplierRequestDto, options).then((request) => request(this.axios, this.basePath));
    }
}

